import React, { useContext, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { Box } from "@material-ui/core";

import useTabStyles from "../../styles/Tab.style";
import useStyles from "./WithdrawRequestsTab.style";
import { PageTitle } from "../../../../components/page-title/PageTitle";
import Paginator, { DataTypeEnum } from "../../../../models/Paginator";
import {
  ICIPAdminActionTypeEnum,
  ICIPAdminDispatchContext,
} from "../../../../context/ICIPAdminContext";
import ICIPAdminService from "../../../../services/ICIPAdminService";
import { WithdrawRequestsTabPanel } from "../../tab-panels/withdraw-request/WithdrawRequestsTabPanel";

interface WithdrawRequestsTabProps {}

export interface WithdrawRequestsTabData {
  original: Paginator;
  filtered: Paginator;
}

export const WithdrawRequestsTab = (props: WithdrawRequestsTabProps) => {
  const tabClasses = useTabStyles(props);
  const intl = useIntl();
  // Context
  const dispatch = useContext(ICIPAdminDispatchContext);
  // State
  const [paginator, setPaginator] = useState((): WithdrawRequestsTabData => null);
  const [withdrawRequests, setWithdrawRequests] = useState((): any => []);

  // Fetch data

  const fetchData = () => {
    ICIPAdminService.getWithdrawRequests().then((response) => {
      if (response.isSuccess && response.data.code === 100) {
        let reqPaginator = Paginator.fromJson(
          JSON.parse(JSON.stringify(response.data.data)),
          DataTypeEnum.withdraw_requests
        );

        let data = JSON.parse(JSON.stringify(response.data.data));

        // Set state
        setWithdrawRequests(data);
        setPaginator({
          original: reqPaginator,
          filtered: reqPaginator,
        });

        dispatch({
          type: ICIPAdminActionTypeEnum.loaded,
        });
          
      } else {
        dispatch({
          type: ICIPAdminActionTypeEnum.error,
          data: {
            error: intl.formatMessage({ id: "error.unknownError" }),
          },
        });
      }
    });
  };

  // Renders

  useEffect(() => {
    dispatch({
      type: ICIPAdminActionTypeEnum.loading,
    });
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <PageTitle
        withAppTitle={false}
        title={`${intl.formatMessage({
          id: "sharedScreen.admin",
        })} - ${intl.formatMessage({
          id: "sharedScreen.withdrawRequests",
        })}`}
      />
      {paginator !== null ? (
        <Box className={tabClasses.root}>
          <Box className={tabClasses.wrapper}>
                <WithdrawRequestsTabPanel
                  paginator={paginator.filtered}
                  withdrawRequests={withdrawRequests}
                />
            </Box>
        </Box>
      ) : (
        <></>
      )}
    </>
  );
};
